import { z } from 'zod/v3';

export const IDENTITY_ROLE_ASSIGNMENT_SCHEMA_VERSION = 2;

export const IdentityRoleAssignment = z.object({
  externalId: z.string(),
  principalExternalId: z.string(),
  principalName: z.string().nullable(),
  roleExternalId: z.string(),
  roleName: z.string().nullable(),
  roleType: z.string().nullable(),
  applicationExternalId: z.string().nullable(),
  applicationName: z.string().nullable(),
  assignmentType: z.enum(['direct', 'group', 'unknown']),
  isPrivileged: z.boolean(),
  assignedAt: z.string().datetime().nullable(),
  updatedAt: z.string().datetime().nullable(),
});

export type IdentityRoleAssignment = z.infer<typeof IdentityRoleAssignment>;
